module.exports = __webpack_public_path__ + "saira-medium-webfont.f49eee7988578458b9b4.eot";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-medium-webfont.eot
// module id = ../../../../../src/assets/fonts/saira-medium-webfont.eot
// module chunks = styles